'use client';
import React, { useState } from 'react';

import Header from '@/components/Header';
import Footer from '@/components/Footer';

interface Product {
  id: number;
  name: string;
  category: string;
  badge: string;
  badgeColor: string;
  image: string;
  price: string;
  originalPrice: string;
  discount: string;
  rating: string;
  reviews: string;
  desc: string;
}

const allProducts: Product[] = [
{ id: 1, name: 'HP DeskJet 2331 All-in-One', category: 'Inkjet', badge: 'Best Seller', badgeColor: '#0057b8', image: "https://img.rocket.new/generatedImages/rocket_gen_img_19a0292fc-1764765555385.png", price: '$89', originalPrice: '$119', discount: '25% off', rating: '⭐⭐⭐⭐⭐', reviews: '(1842)', desc: 'Compact all-in-one for everyday home printing. Print, scan, and copy with ease.' },
{ id: 2, name: 'HP ENVY 6055e All-in-One', category: 'Inkjet', badge: 'Top Rated', badgeColor: '#7c3aed', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f656840f-1778105600517.png", price: '$149', originalPrice: '$189', discount: '21% off', rating: '⭐⭐⭐⭐⭐', reviews: '(2156)', desc: 'Smart wireless all-in-one with HP+ smart printing system and Instant Ink ready.' },
{ id: 3, name: 'HP LaserJet M110we', category: 'Laser', badge: '', badgeColor: '', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cd73dc42-1767773988733.png", price: '$199', originalPrice: '$249', discount: '20% off', rating: '⭐⭐⭐⭐⭐', reviews: '(987)', desc: 'Ultra-compact wireless monochrome laser — perfect for small offices and WFH setups.' },
{ id: 4, name: 'HP OfficeJet Pro 9015e', category: 'Inkjet', badge: 'Pro Choice', badgeColor: '#059669', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d504334b-1778105600813.png", price: '$279', originalPrice: '$349', discount: '20% off', rating: '⭐⭐⭐⭐⭐', reviews: '(3201)', desc: 'Professional-grade all-in-one for high-volume office printing with business features.' },
{ id: 5, name: 'HP Color LaserJet Pro MFP 4303', category: 'Laser', badge: 'NEW', badgeColor: '#dc2626', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1fc61707d-1778105600517.png", price: '$499', originalPrice: '$599', discount: '17% off', rating: '⭐⭐⭐⭐⭐', reviews: '(645)', desc: 'Colour laser MFP built for office efficiency — fast, sharp, and network-ready.' },
{ id: 6, name: 'HP Smart Tank 580 All-in-One', category: 'Ink Tank', badge: 'Eco Friendly', badgeColor: '#16a34a', image: "https://img.rocket.new/generatedImages/rocket_gen_img_17893953a-1778105600512.png", price: '$219', originalPrice: '$279', discount: '21% off', rating: '⭐⭐⭐⭐⭐', reviews: '(1729)', desc: 'Low cost-per-page inkjet with cartridge-free tank system. Great for heavy users.' },
{ id: 7, name: 'HP DeskJet Ink Advantage 5275', category: 'Inkjet', badge: '', badgeColor: '', image: "https://img.rocket.new/generatedImages/rocket_gen_img_13b817d7b-1778105600631.png", price: '$109', originalPrice: '$139', discount: '22% off', rating: '⭐⭐⭐⭐⭐', reviews: '(2310)', desc: 'Budget-friendly wireless all-in-one with Ink Advantage for lower running costs.' },
{ id: 8, name: 'HP LaserJet Pro 4004dn', category: 'Laser', badge: 'Enterprise', badgeColor: '#1d4ed8', image: "https://img.rocket.new/generatedImages/rocket_gen_img_101c569fc-1778105600993.png", price: '$399', originalPrice: '$479', discount: '17% off', rating: '⭐⭐⭐⭐⭐', reviews: '(412)', desc: 'High-speed monochrome laser for busy offices demanding reliability and speed.' },
{ id: 9, name: 'HP DeskJet 4826', category: 'Inkjet', badge: 'New', badgeColor: '#16a34a', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f656840f-1778105600517.png", price: '$129', originalPrice: '$159', discount: '19% off', rating: '⭐⭐⭐⭐⭐', reviews: '(134)', desc: 'Smart wireless all-in-one with HP+ smart printing system and Instant Ink ready.' },
{ id: 10, name: 'HP Smart Tank 589', category: 'Ink Tank', badge: 'Best Seller', badgeColor: '#0057b8', image: "https://img.rocket.new/generatedImages/rocket_gen_img_13748dcb8-1773632521497.png", price: '$199', originalPrice: '$239', discount: '17% off', rating: '⭐⭐⭐⭐⭐', reviews: '(267)', desc: 'Wireless ink tank with huge capacity — ideal for homes and small teams printing daily.' },
{ id: 11, name: 'HP LaserJet MFP M141w', category: 'Laser', badge: 'Sale', badgeColor: '#FF6B00', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cd73dc42-1767773988733.png", price: '$174', originalPrice: '$215', discount: '19% off', rating: '⭐⭐⭐⭐⭐', reviews: '(312)', desc: 'Ultra-compact wireless monochrome laser — perfect for small offices and WFH setups.' },
{ id: 12, name: 'HP Sprocket Plus', category: 'Photo', badge: 'New', badgeColor: '#16a34a', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1787b1e96-1778105600536.png", price: '$65', originalPrice: '$84', discount: '23% off', rating: '⭐⭐⭐⭐⭐', reviews: '(312)', desc: 'Pocket-sized photo printer that connects to your phone. Print 2×3 zink photos instantly.' }];

const categories = ['All', 'Inkjet', 'Laser', 'Ink Tank', 'Photo'];

export default function ShopPage() {
  const [activeCategory, setActiveCategory] = useState('All');
  const [cartItems, setCartItems] = useState<number[]>([]);
  const [toast, setToast] = useState('');
  const [search, setSearch] = useState('');
  const [sort, setSort] = useState('Featured');

  const filtered = allProducts
    .filter((p) => activeCategory === 'All' || p.category === activeCategory)
    .filter((p) => p.name.toLowerCase().includes(search.toLowerCase()))
    .sort((a, b) => {
      if (sort === 'Price: Low to High') return parseInt(a.price.replace('$', '')) - parseInt(b.price.replace('$', ''));
      if (sort === 'Price: High to Low') return parseInt(b.price.replace('$', '')) - parseInt(a.price.replace('$', ''));
      return 0;
    });

  const addToCart = (product: Product) => {
    setCartItems((prev) => [...prev, product.id]);
    setToast(`✓ ${product.name} added to cart!`);
    setTimeout(() => setToast(''), 3000);
  };

  return (
    <div>
      <Header />

      {/* Page Hero */}
      <div className="page-hero">
        <div className="page-hero-grid" />
        <div className="page-hero-glow" />
        <div style={{ maxWidth: 1280, margin: '0 auto', position: 'relative', zIndex: 1 }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, background: 'rgba(0,92,187,0.25)', border: '1px solid rgba(0,92,187,0.4)', color: '#70aeff', fontSize: 12, fontWeight: 600, letterSpacing: '1.5px', padding: '6px 14px', borderRadius: 99, textTransform: 'uppercase', marginBottom: '1.2rem' }}>
            <span style={{ width: 6, height: 6, background: '#70aeff', borderRadius: '50%', display: 'inline-block' }}></span>
            Our Store
          </div>
          <h1 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 800, fontSize: 'clamp(2.2rem, 4vw, 3.4rem)', color: '#fff', lineHeight: 1.15, marginBottom: '0.75rem' }}>
            Shop <span style={{ color: '#FF6B00' }}>HP Printers</span>
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '1.05rem', lineHeight: 1.7, maxWidth: 560 }}>Explore our complete range of HP printers — inkjet, laser, ink tank, and photo.</p>
        </div>
      </div>

      {/* Filters + Products */}
      <section style={{ padding: '48px 16px', background: '#f0f4ff' }}>
        <div style={{ maxWidth: 1280, margin: '0 auto' }}>
          {/* Category Tabs */}
          <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 32 }}>
            {categories.map((cat) =>
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                style={{
                  padding: '8px 20px',
                  borderRadius: 999,
                  border: activeCategory === cat ? 'none' : '1px solid #e2e8f4',
                  background: activeCategory === cat ? '#0057b8' : '#fff',
                  color: activeCategory === cat ? '#fff' : '#374151',
                  fontWeight: 600,
                  fontSize: 14,
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}>
                {cat}
              </button>
            )}
          </div>

          {/* Search + Sort */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24, flexWrap: 'wrap', gap: 12 }}>
            <div style={{ color: '#374151', fontWeight: 600 }}>Showing <strong>{filtered.length}</strong> HP Printers</div>
            <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, background: '#fff', border: '1px solid #e2e8f4', borderRadius: 8, padding: '8px 12px' }}>
                <span>🔍</span>
                <input
                  type="text"
                  placeholder="Search printers..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={{ border: 'none', outline: 'none', fontSize: 14, background: 'transparent', width: 180 }} />
              </div>
              <select
                value={sort}
                onChange={(e) => setSort(e.target.value)}
                style={{ border: '1px solid #e2e8f4', borderRadius: 8, padding: '8px 12px', fontSize: 14, background: '#fff', cursor: 'pointer', outline: 'none' }}>
                <option>Featured</option>
                <option>Price: Low to High</option>
                <option>Price: High to Low</option>
                <option>Top Rated</option>
              </select>
            </div>
          </div>

          {/* Products Grid */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 24 }}>
            {filtered.map((product) =>
              <div key={product.id} className="product-card">
                <div className="product-img-wrap">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="product-img"
                    onError={(e) => { (e.target as HTMLImageElement).src = `https://via.placeholder.com/160x140/e8f1ff/0057b8?text=${encodeURIComponent(product.name.split(' ').slice(0, 2).join('+'))}`; }} />
                  {product.badge &&
                    <span style={{ position: 'absolute', top: 12, left: 12, background: product.badgeColor, color: '#fff', fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 6 }}>{product.badge}</span>
                  }
                </div>
                <div style={{ padding: '1.25rem' }}>
                  <div style={{ fontSize: 11, color: '#005CBB', fontWeight: 700, letterSpacing: '0.5px', textTransform: 'uppercase', marginBottom: 4 }}>{product.category}</div>
                  <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: 15, color: '#1A2235', marginBottom: 6, lineHeight: 1.3 }}>{product.name}</div>
                  <div style={{ fontSize: 12, color: '#6B7A99', lineHeight: 1.6, marginBottom: 12 }}>{product.desc}</div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginBottom: 12 }}>
                    <span style={{ color: '#ffb800', fontSize: 12 }}>★★★★★</span>
                    <span style={{ fontSize: 12, color: '#6B7A99' }}>{product.reviews}</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div>
                      <span style={{ fontFamily: 'Syne, sans-serif', fontWeight: 800, fontSize: 20, color: '#1A2235' }}>{product.price}</span>
                      <span style={{ fontSize: 13, color: '#6B7A99', textDecoration: 'line-through', marginLeft: 6 }}>{product.originalPrice}</span>
                    </div>
                    <button
                      onClick={() => addToCart(product)}
                      style={{ background: '#005CBB', color: '#fff', border: 'none', cursor: 'pointer', width: 38, height: 38, borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, transition: 'background 0.2s, transform 0.15s' }}
                      onMouseEnter={(e) => { e.currentTarget.style.background = '#003D7A'; e.currentTarget.style.transform = 'scale(1.1)'; }}
                      onMouseLeave={(e) => { e.currentTarget.style.background = '#005CBB'; e.currentTarget.style.transform = 'scale(1)'; }}>
                      +
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      <Footer />

      {toast &&
        <div style={{ position: 'fixed', bottom: 24, right: 24, background: '#22c55e', color: '#fff', padding: '12px 24px', borderRadius: 12, boxShadow: '0 8px 24px rgba(0,0,0,0.2)', fontWeight: 600, fontSize: 14, zIndex: 9999 }}>
          {toast}
        </div>
      }
    </div>
  );
}